import type { ReactNode } from 'react';
import {
  StarOutlined,
  CrownOutlined,
  RocketOutlined,
  GiftOutlined,
  SafetyOutlined,
} from '@ant-design/icons';
import type { PlanTheme } from '../../types/business';

/**
 * Resolves icon JSX from BE-provided icon kind string.
 * Fallback to StarOutlined for unknown kinds.
 */
export function resolvePlanIcon(kind: string): ReactNode {
  switch (kind) {
    case 'crown':
      return <CrownOutlined />;
    case 'rocket':
      return <RocketOutlined />;
    case 'gift':
      return <GiftOutlined />;
    case 'shield':
      return <SafetyOutlined />;
    case 'star':
    default:
      return <StarOutlined />;
  }
}

/**
 * Lighten a hex color by a percentage (used for gradient end-stops).
 */
function lighten(hex: string, percent: number): string {
  const cleaned = hex.replace('#', '');
  const num = parseInt(cleaned, 16);
  const r = Math.min(255, ((num >> 16) & 0xff) + Math.round(255 * (percent / 100)));
  const g = Math.min(255, ((num >> 8) & 0xff) + Math.round(255 * (percent / 100)));
  const b = Math.min(255, (num & 0xff) + Math.round(255 * (percent / 100)));
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
}

/**
 * Build hero gradient from BE-provided accent colors.
 */
export function buildHeroGradient(theme: PlanTheme): string {
  return `linear-gradient(135deg, ${theme.accentDark} 0%, ${theme.accent} 60%, ${lighten(theme.accent, 18)} 100%)`;
}
